import { HomeIcon } from '@heroicons/react/solid'
import type { ReactElement } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ErrorTemplate } from './Template'
import CustomButton from '../Shared/UIComponents/Button'

type Props = {
  children?: ReactElement
}

export function ErrorNotFound(props: Props) {
  const location = useLocation()
  const navigate = useNavigate()

  return (
    <ErrorTemplate
      title="404 - Not found"
      message={
        <>
          The page at <b>{location.pathname}</b> doesn't exist.
        </>
      }
      button={
        <CustomButton
          label="go home"
          onClick={() => navigate('/', { replace: true })}
          icon={<HomeIcon />}
          iconPosition="left"
        />
      }
      extraButton={props.children}
    />
  )
}
